import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(
    private authService: AuthenticationService,
    private http: HttpClient,
    private router: Router
  ) {}

  get(url: string) {
    return this.http.get(url, this.getAuthHeader()).pipe(
      catchError((err) => {
        if (err.status === 808) {
          // refresh the access token and pass the 808 up to the calling method
          return this.authService.refreshAccessToken().pipe(
            map((success) => {
              throw err;
            }),
            catchError((error) => {
              if (error.status !== 808) {
                //this.router.navigate(['/login']);
                return of(null);
              }
              throw error;
            })
          );
        } else {
          throw err;
        }
      })
    );
  }

  put(url: string, body: any) {
    return this.http.put(url, JSON.stringify(body), this.getAuthHeader()).pipe(
      catchError((err) => {
        if (err.status === 808) {
          // refresh the access token and pass the 808 up to the calling method
          return this.authService.refreshAccessToken().pipe(
            map((success) => {
              throw err;
            }),
            catchError((error) => {
              if (error.status !== 808) {
                //this.router.navigate(['/login']);
                return of(null);
              }
              throw error;
            })
          );
        } else {
          throw err;
        }
      })
    );
  }

  post(url: string, body: any) {
    return this.http.post(url, JSON.stringify(body), this.getAuthHeader()).pipe(
      catchError((err) => {
        if (err.status === 808) {
          // refresh the access token and pass the 808 up to the calling method
          return this.authService.refreshAccessToken().pipe(
            map((success) => {
              throw err;
            }),
            catchError((error) => {
              if (error.status !== 808) {
                //this.router.navigate(['/login']);
                return of(null);
              }
              throw error;
            })
          );
        } else {
          throw err;
        }
      })
    );
  }

  private getAuthHeader() {
    let headers = new HttpHeaders();
    //headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', `Bearer ${this.authService.getAccessToken()}`);
    return { headers: headers };
  }
}
